import React, { useState } from "react";
import QuickBuyPopup from './QuickBuyPopup';
 
const QuickBuy = props => {
    const [isOpen, setIsOpen] = useState(false);
 
    const togglePopup = () => {
      setIsOpen(!isOpen);
    }

    return (
        <>
            <button className="quickbuy-button" onClick={togglePopup}>
                <img
                    src="/ui/images/shopping-bag-black.svg"
                    alt="Cart icon"
                />
            </button>


            {isOpen && 
                <QuickBuyPopup 
                    handleClose={togglePopup}
                    productAvailableColors={props.productAvailableColors}
                    productSizeInputFields={props.productSizeInputFields}
                    gtmTrackingData={props.gtmTrackingData}
                />
            }
        </>
    )
}
 
export default QuickBuy;